import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './TranslationsFormInput.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import Edit from '../../../Edit/Edit';
import "../../../CheckBox/CheckBox";
import { CountryCodeIti, Language, LanguagesEnglish, LanguagesGerman } from "../TranslationsFormTypes";
import CheckBox from '../../../CheckBox/CheckBox';
class TranslationsFormInput extends compose(_WidgetBaseSP) {

    templateString: string = template;

    private _language: Language;
    private _sourceLanguage: Language;

    sourceLanguageCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private inputLabel: HTMLLabelElement;
    private textInput: MdsLax<InstanceType<typeof Edit>>;
    private languageIcon: HTMLSpanElement;
    private translateButtonContainer: HTMLDivElement;
    private translateButton: HTMLButtonElement;
    private translateButtonSourceLanguageIcon: HTMLDivElement;
    private translateButtonTargetLanguageIcon: HTMLDivElement;

    setMultiline(bMultiline: boolean = true, rows?: number) {
        this.textInput.setIsMultiline(bMultiline !== false, rows);        
    }

    setIsHtmlEdit(bHtmlEdit: boolean = true) {
        if(this.textInput.setIsHtmlEdit)this.textInput.setIsHtmlEdit(bHtmlEdit);
    }

    setMandatory(bMandatory: boolean = true) {
        this.textInput.setMandatory(bMandatory !== false);
    }

    setLanguage(language: Language, sourceLanguage: Language) {
        this._language = language;
        this.setSourceLanguage(sourceLanguage);
        //Set German label if specified otherwise English
        this.setInputLabel();
        var targetLanguageClass = `iti__${CountryCodeIti[this._language]}`;
        this.languageIcon.classList.add(targetLanguageClass);
        this.UiModder.domClass.add(this.translateButtonTargetLanguageIcon, targetLanguageClass);
    }

 
    getValue(): string {
        return this.textInput.getValue();
    }

    getLanguageCode(): Language {
        return this._language;
    }

    setValue(text: string, suppressChangeEvent?: boolean) {
        this.textInput.setValue(text, suppressChangeEvent);
    }

    setDangerStyle(isInDanger: boolean): void {
        var isLightMode: boolean = window.themeToggler.getTheme() === "light";

        if (isInDanger) {
            if (isLightMode) {
                this.UiModder.domClass.add(this.domNode, "warningYellowBG");
            } else {
                this.UiModder.domClass.add(this.domNode, "warningBG");
            }      
        } else {
            if (isLightMode) {
                this.UiModder.domClass.remove(this.domNode, "warningYellowBG");
            } else {
                this.UiModder.domClass.remove(this.domNode, "warningBG");
            }  
        }
    }

    setSourceLanguage(sourceLanguageCode: Language) {
        if (!sourceLanguageCode) sourceLanguageCode = window.currentLanguageCode as Language;
        if (!sourceLanguageCode) return;

        this._sourceLanguage = sourceLanguageCode;
        this._setTranslateButtonSourceLanguageIcon();
        this._setButtonStatus();
        this._setCheckBoxStatus();

        if (this.getLanguageCode() === sourceLanguageCode) {
            this.setDangerStyle(false);
        }

        this._setTranslateButtonSourceLanguageIcon();

    }

    private _setButtonStatus(): void {
        let sourceLanguageCode: string = this._sourceLanguage;
        var isDeactivated = sourceLanguageCode === this._language || !this.hasFeature("Multilang/EnableMultiLangEdit");
        this.disableNode(this.translateButton, isDeactivated);
    }

    private _setCheckBoxStatus(): void {
        let sourceLanguageCode: Language = this._sourceLanguage;
        //If the sourceLanguage is equial to this language the box is already checked
        var isChecked = sourceLanguageCode === this._language;
        this.sourceLanguageCheckbox.setChecked(isChecked, true);
        //Deactivate the checkbox if it is checked
        if (isChecked) {
            this.sourceLanguageCheckbox.isReadonly = true;
        } else {
            this.sourceLanguageCheckbox.isReadonly = false;
        }
        
    }

    //removeTranslateButtonSourceLanguageIcon(): void {
    //    //this.UiModder.domClass.remove(this.translateButtonSourceLanguageIcon, `iti__${CountryCodeIti[languageCode]}`);
    //}

    private _setTranslateButtonSourceLanguageIcon(): void {
        
        let languageCode: string = this._sourceLanguage;
        this.UiModder.domClass.remove(this.translateButtonSourceLanguageIcon); // alle bisherigen entfernen

        this.UiModder.domClass.add(this.translateButtonSourceLanguageIcon, `iti__flag iti__${CountryCodeIti[languageCode]}`);
    }

    private setInputLabel(): void {
        if (window.currentLanguageCode2 === "de") {
            this.inputLabel.innerText = LanguagesGerman[this._language];
        } else {
            this.inputLabel.innerText = LanguagesEnglish[this._language];
        }
    }

    private _onChangeTranslation(): void {
        this.emit("change", this);
    }

    private _onClickTranslate(): void {
        this.emit("requestTranslation", this);
    }

   
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (!this.hasFeature("Multilang/EnableTranslation")) {
            this.disableNode(this.translateButton, true);
            this.hideNode(this.sourceLanguageCheckbox, true);
            this.hideNode(this.translateButtonContainer, true);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    
}

mdsLazyProto(TranslationsFormInput.prototype, {
  sourceLanguageCheckbox: () => (new CheckBox()),
  textInput: () => (new Edit()),
});
export default mdsWidget(TranslationsFormInput);